// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__81vaF flex_row","spinner":"loader_spinner__2Wn5v","spin":"loader_spin__hZ96F"};